import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import audioReducer from '../features/audio';
import tokenReducer from '../features/token';
import chainReducer from '../features/chain';
import accountReducer from '../features/account';
import imageReducer from '../features/image';
import tradeReducer from '../features/trade';

export const store = configureStore({
    reducer: {
        audio: audioReducer,
        token: tokenReducer,
        chain: chainReducer,
        account: accountReducer,
        image: imageReducer,
        trade: tradeReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;


export const fetchPrice = () => {
    const state = store.getState();
    return state.trade.price;
}
export const getMinSell = (): number => {
    const price = fetchPrice();
    const min = (0.00001 / parseFloat(price)).toFixed(18);
    return parseFloat(min);
}